import React, {useCallback, useRef, useState} from 'react';
import {Grid} from "@mui/material";
import InvoiceFilterForm from '../components/invoice/InvoiceFilterForm';
import InvoiceTable from '../components/invoice/InvoiceTable';
import InvoiceStatisticsTable from '../components/statistics/InvoiceStatisticsTable';
import InvoiceFilter from '../core/api/invoice/InvoiceFilterModel';
import InvoiceModel from '../core/api/invoice/InvoiceModel';
import {FilterDrawer} from '../components/common/FilterDrawer';
import PageRequest from '../core/api/PageRequest';

const defaultFilter: InvoiceFilter = {
  dateFrom: '',
  dateTo: '',
  author: '',
};

export const Invoices: React.FC = () => {
  const [filter, setFilter] = useState<InvoiceFilter>(defaultFilter);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const invoiceTableRef = useRef<any>(null);

  const handleFilterToggle = useCallback(() => {
    setIsFilterOpen(prev => !prev);
  }, []);

  const handleFilterChange = useCallback((newFilter: InvoiceFilter) => {
    setFilter(prevFilter => ({...prevFilter, ...newFilter}));
  }, []);

  const handleFetchInvoices = useCallback((page: PageRequest) => {
    return InvoiceModel.listAll(page, filter);
  }, [filter]);

  const mainContent = (
      <Grid container spacing={3} justifyContent="center" direction="column">
        <Grid size={12}
        >
          <InvoiceTable
              tableRef={invoiceTableRef}
              fetchFunction={handleFetchInvoices}
          />
        </Grid>
        <Grid size={12}>
          <InvoiceStatisticsTable filter={filter}/>
        </Grid>
      </Grid>
  );

  const filterContent = (
    <InvoiceFilterForm
      filter={filter}
      onFilterChange={handleFilterChange}
    />
  );

  return (
    <FilterDrawer
      open={isFilterOpen}
      onToggle={handleFilterToggle}
      filterContent={filterContent}
    >
      {mainContent}
    </FilterDrawer>
  );
};
